module.exports = __webpack_public_path__ + "img/minus-icon.76f556e4.svg";